var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (filterRoot, sd, sections) {
jade_mixins["filter-dropdown"] = jade_interp = function(mainText, plural, attr, values, hrefRoot){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"filter-dropdown\"><div class=\"filter-nav-main-text\">" + (jade.escape(null == (jade_interp = mainText) ? "" : jade_interp)) + "</div><div class=\"filter-nav-active-text\"></div><div class=\"icon-arrow-down\"></div><nav><a" + (jade.attr("data-attr", attr, true, true)) + " data-val=\"\" href=\"\" class=\"is-active\"><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = "All " + plural) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
// iterate values
;(function(){
  var $$obj = values;
  if ('number' == typeof $$obj.length) {

    for (var label = 0, $$l = $$obj.length; label < $$l; label++) {
      var val = $$obj[label];

if ( label && val)
{
buf.push("<a" + (jade.attr("data-attr", attr, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              hrefRoot && hrefRoot.match('booths') ?
              "" + (hrefRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (hrefRoot ? hrefRoot : sd.CURRENT_PATH + '/artworks') + "?" + (attr) + "=" + (val) + ""
            ), true, true)) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
}
    }

  } else {
    var $$l = 0;
    for (var label in $$obj) {
      $$l++;      var val = $$obj[label];

if ( label && val)
{
buf.push("<a" + (jade.attr("data-attr", attr, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              hrefRoot && hrefRoot.match('booths') ?
              "" + (hrefRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (hrefRoot ? hrefRoot : sd.CURRENT_PATH + '/artworks') + "?" + (attr) + "=" + (val) + ""
            ), true, true)) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
}
    }

  }
}).call(this);

buf.push("</nav></div>");
};
jade_mixins["filter-dropdown"]('Section', 'Sections', 'section', sections, filterRoot);}.call(this,"filterRoot" in locals_for_with?locals_for_with.filterRoot:typeof filterRoot!=="undefined"?filterRoot:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"sections" in locals_for_with?locals_for_with.sections:typeof sections!=="undefined"?sections:undefined));;return buf.join("");
};
module.exports = template;